import Cart from './Cart'
import {defaultAlert, errorAlert, successAlert} from "./jquery-confirm";
import {btnLoading, makeSpinner} from "./Helpers";

const cartFactory = new Cart;
window.OoredooOdsCart = {

    hasProcess: function () {
        return cartFactory.hasProcess();
    },

};

const fillCartHeaderBox = (cartResponse) => {
    if (!cartResponse.html) {
        return;
    }
    $('.header-cart-box').html(cartResponse.html)
}

(($) => {
    $(document).ready(function () {

        if (typeof navigator.cookieEnabled === 'boolean' && !navigator.cookieEnabled) {
            let cookieMessage = `<div class="container">
<div class="alert" style="
    margin: 10px 0 -2px 0px;
">يرجى تفعيل الكوكيز على متصفحك لتتمكن من استخدام الموقع بدون مشاكل</div>
</div>`;
            $('#content-wrapper').prepend(cookieMessage);

        }

        $('body').on('click', '.header-cart', function (e) {
            e.preventDefault();
            $(this).closest('.menu-portal-cart-wrapper').find('.header-cart-box').toggleClass('is-active');
        });
        $('body').on('click', function (e) {
            const target = e.target;
            if (!target) {
                return;
            }
            const box = $('body').find('.header-cart-box');
            if ($(target).closest('.jconfirm').length) {
                return;
            }

            if (!$(target).closest('.menu-portal-cart-wrapper').length) {
                box.removeClass('is-active')
            }
        });


        const updateCartElements = (response) => {
            fillCartHeaderBox(response);

            if (typeof response.cart !== 'undefined') {
                const totalBox = $('body').find('.ods-cart__footer__total-box');
                if (totalBox.length) {
                    totalBox
                        .html(window._ods_functions.price_format(response.cart.total));
                }


                const counter = $('body').find('.header-cart-count');
                if (!response.cart.count) {
                    counter.text('');
                } else {
                    counter.text(response.cart.count);
                }


            }
        }
        const handleCartResponse = (response, isError = false) => {

            let config = {};
            if (isError) {
                config.content = window.application.ods.js_trans.something_went_wrong;
                if (typeof response.responseJSON !== 'undefined') {
                    response = response.responseJSON;
                }
            }

            if (response.message) {
                config.content = response.message;
            }

            if (typeof response.alert !== 'undefined') {
                if (typeof response.alert.buttons !== 'undefined') {
                    $.each(response.alert.buttons, function (idx, btn) {

                        if (typeof btn.action === 'undefined') {
                            btn.action = function () {
                                const self = this;
                                if (typeof btn.redirect_to !== 'undefined' && btn.redirect_to.indexOf('http') === 0) {
                                    self.showLoading(true);
                                    window.location.href = btn.redirect_to;
                                    return false;
                                } else if (typeof btn.reload_page !== 'undefined' && btn.reload_page === true) {
                                    self.showLoading(true);
                                    window.location.reload();
                                    return false;
                                }
                            }
                        }
                    })
                }

                config = $.extend(config, response.alert);

            }
            config.jqueryConfirmClasses = 'jconfirm-ooredoo--cart-popup';
            config.columnClass = 'column is-7 col-push-2';

            if (isError) {
                errorAlert(config.content, config);
            } else {
                successAlert(config.content, config);
            }
        }

        let onChangeQuanitytInterval = false;
        const onChangeQuantity = (input) => {
            if (false !== input[0].onChangeQuanitytInterval) {
                clearInterval(input[0].onChangeQuanitytInterval);
            }
            const row = input.closest('.ods-cart-product-row');

            const cartId = row.data('cart_id');
            const _pid = row.data('product_id');
            let q = input.val();

            if (!row.find('.lds-ring').length) {
                row.prepend(makeSpinner('', 'ods-cpr-loader'));
            }

            row.addClass('ods-cpr--is-loading')

            cartFactory.updateCart(cartId, _pid, q)
                .then((res) => {
                    row.find('.ods-cpr-loader').remove();
                    row.removeClass('ods-cpr--is-loading');
                    updateCartElements(res);

                    return res;
                })
                .catch((res) => {
                    row.find('.ods-cpr-loader').remove();
                    row.removeClass('ods-cpr--is-loading');
                    handleCartResponse(res, true)
                    return res;
                })

        }
        $('body').on('change', '.ods-quantity-field__input', function (e) {
            if (typeof this.onChangeQuanitytInterval === 'undefined') {
                this.onChangeQuanitytInterval = false;
            }
            if (false !== this.onChangeQuanitytInterval) {
                clearInterval(this.onChangeQuanitytInterval);
            }

            const input = $(this);
            this.onChangeQuanitytInterval = setInterval(() => {
                onChangeQuantity(input);
            }, 1000);


        });

        $('body').on('click', '[data-cart_remove]', function (e) {
            e.preventDefault();
            const btn = $(this);
            defaultAlert('هل أنت متأكد من إزالة هذا المنتج من سلة المشتريات؟', {
                jqueryConfirmClasses: 'jconfirm-ooredoo--cart-popup',
                columnClass: 'column is-7 col-push-2',
                buttons: {

                    confirm: {
                        text: window.application.ods.js_trans.confirm,
                        btnClass: 'main-btn',
                        action: function () {
                            const me = this;
                            me.showLoading(true);
                            cartFactory.removeFromCart(btn.data('cart_id'))
                                .then((res) => {

                                    $.each($('body').find(`.ods-cart-product-row[data-product_id="${btn.attr('data-product_id')}"]`), function (idx,el){
                                        $(el).closest('.ods-cart-product-row').stop().slideUp('fast', function () {
                                            $(this).remove();
                                        });
                                    })

                                    btn.closest('.ods-cart-product-row').stop().slideUp('fast', function () {
                                        $(this).remove();
                                    });

                                    updateCartElements(res);

                                    cartFactory.listCart()
                                        .then((res) => {
                                            updateCartElements(res);
                                        })
                                        .catch((res) => {

                                        })

                                    me.close();
                                    return res;
                                })
                                .catch((res) => {
                                    me.hideLoading(true);
                                    handleCartResponse(res, true);
                                    me.close();
                                    return res;
                                })

                            return false;
                        },
                    },
                    back: {
                        text: window.application.ods.js_trans.back,
                        btnClass: 'main-btn-outline',
                    },
                }
            })
        });
        $('body').on('click', '[data-add_to_cart]', function (e) {
            e.preventDefault();
            const inCart = parseInt($(this).attr('data-product_in_cart'), 10);
            if (inCart === 1) {
                let url = $(this).data('cart_url');
                if (url && url.toString().indexOf('http') === 0) {
                    window.location.href = url;
                    return;
                }
            }

            let _this = $(this);
            let _pid = _this.data('product_id');
            let _q = _this.data('quantity');
            if (typeof _q === 'undefined') {
                _q = 1;
            }
            _q = _q * 1;
            if (isNaN(_q) || _q < 1) {
                _q = 1;
            }

            if (typeof _pid === 'undefined') {
                return false;
            }

            btnLoading(_this, true)

            cartFactory.addToCart(_pid, _q)
                .then((res) => {
                    btnLoading(_this, false)
                    handleCartResponse(res);
                    updateCartElements(res);
                    // $('body').find('.header-cart-box').addClass('is-active');

                    return res;
                })
                .catch((res) => {
                    btnLoading(_this, false)
                    handleCartResponse(res, true);
                    return res;
                })


        });

        cartFactory.listCart()
            .then((res) => {
                updateCartElements(res);
            })
            .catch((res) => {

            })


    });
})(jQuery);
